import type { ContactStep } from '@/types'

export const CONTACT_TOPICS = [
    'General question',
    'Pricing',
    'Partnerships',
    'Support',
    'Press',
    'Something else'
]

export const COMPANY_SIZES = [
    'Just me',
    '2–10 people',
    '11–50 people',
    '51–200 people',
    '201–1,000 people',
    'More than 1,000 people'
]

export const CONTACT_LIMITS = {
    name: 80,
    email: 254,
    company: 120,
    messageMin: 10,
    messageMax: 3000
}

export const CONTACT_STEPS: Array<ContactStep> = [
    {
        label: 'Your email',
        title: "Let's start a conversation",
        description: 'It only takes a minute. Start with your work email.',
        fields: ['email', 'company']
    },
    {
        label: 'About you',
        title: 'Tell us a little about you',
        description: 'This helps us send your message to the right person.',
        fields: ['firstName', 'lastName', 'companySize']
    },
    {
        label: 'Your message',
        title: 'How can we help?',
        description: "Share a few details and we'll take it from there.",
        fields: ['topic', 'message']
    }
]
